<template>
  <div class="answer-item">
    <div class="answer-header">
      <div class="title">
        No {{index}}. {{data.title}}
      </div>
      <div class="type">
        填空题
      </div>
    </div>
    <el-input
      v-model="answer"
      placeholder="请输入内容"
      size="small"
    ></el-input>
    <picture-list
      v-if="showPicture"
      :data="data.photos"
    ></picture-list>
    <video-list
      v-if="showVideo"
      :data="data.videos"
    ></video-list>
  </div>
</template>

<script>
import Question from "./Question";
export default {
  mixins: [Question],
  computed: {
    answer: {
      get() {
        return this.data.answer ? this.data.answer.data : "";
      },
      set() {}
    }
  },
  methods: {
    isArray(data) {
      return Object.prototype.toString.call(data) === "[object Array]";
    }
  }
};
</script>